module.exports = __webpack_public_path__ + "img/logo_KECC_header.f3f837e7.svg";